module.exports = __webpack_public_path__ + "img/gongz.6bdaf43e.jpg";